/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */

/**
 * Schnittstelle zwischen UI und Backend
 */
export default class Search {
    /**
     *
     * @param email
     * @param gpnumber
     * @returns Promise - Suchergebniss oder Fehler
     */
    static simpleSearchC1(email, gpnumber) {
        return Http.get('/search/simple/c1', {
            params: {
                email,
                gpnumber,
            },
        });
    }

    /**
     *
     * @param email
     * @param gpnumber
     * @returns Promise - Suchergebniss oder Fehler
     */
    static simpleSearch(email, gpnumber) {
        return Http.get('/search/simple', {
            params: {
                email,
                gpnumber,
            },
        });
    }

    /**
     *
     * @param gpnumber
     * @returns Promise - Suchergebniss oder Fehler
     */
    static simpleSearchMsp(gpnumber) {
        return Http.get('/search/simple/msp', {
            params: {
                gpnumber,
            },
        });
    }

    /**
     *
     * @param query
     * @returns Promise - Suchergebniss oder Fehler
     */
    static salesforceSearch(query) {
        return Http.post('/search/salesforce', {
            query,
        });
    }
}
